import React, { useEffect, useState } from "react";
import Loading from "../layout/Loading";
import Moment from "react-moment";
import "moment-timezone";
import moment from "moment/min/moment-with-locales";
import { enGB } from "date-fns/locale";
import { Link } from "react-router-dom";

const League = (props) => {
  const [loading, setLoading] = useState(false);
  const [match, setMatch] = useState({});
  const [matchtime, setMatchtime] = useState({});
  const [firstteam, setFirstteam] = useState({});
  const [secondteam, setSecondteam] = useState({});
  const [fixturesid, setFixturesid] = useState(17638647);
  const [matchdata, setMatchdata] = useState({});
  const [firstteamname, setFirstteamname] = useState({});
  const [secondteamname, setSecondteamname] = useState({});
  const [league, setLeague] = useState({});
  const [status, setStatus] = useState({});

  useEffect(() => {
    setLoading(true);
    const fetchdata = () => {
      fetch(
        `${process.env.REACT_APP_API_FOOTBALL}/seasons/${props.match.params.sid}?api_token=${process.env.REACT_APP_API_TOKEN}&include=upcoming,league`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }
      )
        .then((res) => {
          return res.json();
        })
        .catch((err) => {
          console.log(err);
        })
        .then((data) => {
          setMatch(data.data.upcoming.data[0]);
          setStatus(data.data.upcoming.data[0].time);
          setMatchtime(data.data.upcoming.data[0].time.starting_at);
          setFirstteam(data.data.upcoming.data[0].localteam_id);
          setSecondteam(data.data.upcoming.data[0].visitorteam_id);
          setFixturesid(data.data.upcoming.data[0].id);
          setLoading(false);
        });
    };
    fetchdata();

    const fixturesfetchdata = () => {
      fetch(
        `${process.env.REACT_APP_API_FOOTBALL}/fixtures/${fixturesid}?api_token=${process.env.REACT_APP_API_TOKEN}&include=localTeam,visitorTeam,league`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }
      )
        .then((res) => {
          return res.json();
        })
        .catch((err) => {
          console.log(err);
        })
        .then((data) => {
          setMatchdata(data.data);
          setFirstteamname(data.data.localTeam.data);
          setSecondteamname(data.data.visitorTeam.data);
          setLeague(data.data.league.data);
          setLoading(false);
        });
    };
    fixturesfetchdata();
  }, [fixturesid, props]);

  const showloading = () =>
    loading && (
      <div className="d-flex justify-content-center">
        <Loading />
      </div>
    );

  return (
    <div className="container">
      {showloading()}
      <div className="card card-curve p-3">
        <h4>
          <img src={league.logo_path} width="40px" alt="" /> {league.name}
        </h4>
      </div>
      <Link to={`/matchscore/${fixturesid}`} className="link-item">
        <div className="card card-curve mt-2 p-3">
          <div className="row">
            <div className="col-sm-1">
              <p className="status text-center"> {status.status} &nbsp;</p>
            </div>
            <div className="col-sm-3">
              {" "}
              <p className="text-center">
                <img src={firstteamname.logo_path} width="40px" alt="" />{" "}
                {firstteamname.name}{" "}
              </p>
            </div>
            <div className="col-sm-3">
              <p className="text-center">
                <i class="far fa-clock"></i>{" "}
                <Moment unix>{matchtime.timestamp}</Moment>
              </p>
            </div>
            <div className="col-sm-4">
              <p className="text-center">
                <img src={secondteamname.logo_path} width="40px" alt="" />{" "}
                {secondteamname.name}
              </p>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default League;
